export const FileUploadStatus = {
	Idle: "idle",
	Uploading: "uploading",
	Success: "success",
	Error: "error",
} as const;

export type FileUploadStatusValue =
	(typeof FileUploadStatus)[keyof typeof FileUploadStatus];

export type AnnotatedFile = Partial<File> & {
	uri?: string;
	damages?: number[];
	uploaded?: boolean;
	fileKey?: string;
	uploadStatus?: FileUploadStatusValue;
	uploadErrorMessage?: string;
};
export type AnnotatedFileWithInput = {
	file?: AnnotatedFile;
	description?: string;
};
